import { useFeatureFlag } from '@fs/zion-flags'
import { useTranslation } from 'react-i18next'
import { useCanAddPersonalData } from '@fs/zion-permissions'

export default function useAccountLinks() {
  const { t } = useTranslation()
  const contactsFlag = useFeatureFlag('home_header_contacts')
  const [isAuthorized] = useCanAddPersonalData()

  const accountLinks = {
    id: 'account',
    text: t('header.account', 'Account'),
    sub: [
      { id: 'settings', text: t('nav.settings', 'Settings'), url: '/identity/settings/profile' },
      {
        id: 'family_groups',
        text: t('nav.family-groups', 'Family Groups'),
        url: '/groups/family',
      },
      { id: 'contacts', text: t('nav.contacts', 'Contacts'), url: '/groups/contacts/', target: '_blank' },
      { id: 'source_box', text: t('nav.source-box', 'Source Box'), url: '/tree/sources/sourceBox' },
      { id: 'sign_out', text: t('account.sign-out.action', 'Sign Out'), url: '/auth/logout' },
    ],
  }

  accountLinks.sub = accountLinks.sub.filter((link) => {
    let keep = true

    if (link.id === 'contacts' && !contactsFlag.isOn) {
      keep = false
    }
    if (!isAuthorized && link.id === 'family_groups') {
      keep = false
    }

    return keep
  })

  return accountLinks
}
